export const GET_TAX_AMNESTY = 'TAX_AMNESTY/get_tax_amnesty';
export const GET_SINGLE_TAX_AMNESTY = 'TAX_AMNESTY/get_single_tax_amnesty';
export const UPDATE_TAX_AMNESTY = 'TAX_AMNESTY/update_tax_amnesty';
export const CREATE_TAX_AMNESTY = 'TAX_AMNESTY/create_tax_amnesty';
export const DELETE_TAX_AMNESTY = 'TAX_AMNESTY/delete_tax_amnesty';
export const GET_ORDINANCE_REVISION_EFFECTIVITY_AMNSESTY =
'TAX_AMNESTY/get_ordinance_reveision_amnesty';
export const EXPIRE_SOA = 'TAX_AMNESTY/expire_soa';

export const FORM_DATA = {
  name: '',
  description: '',
  ordinance_id: '',
  effectivity_start: '',
  effectivity_end: '',
};
